export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8777.2dfc9ba1.jpg";